import { render, staticRenderFns } from "./ZipUpload.vue?vue&type=template&id=af5f16c4"
import script from "./ZipUpload.vue?vue&type=script&lang=js"
export * from "./ZipUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports